import * as React from "react";

function IconEffect1(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 103 84"
            {...props}
        >
            <path
                d="M34.885 0v14.127c1.075-2.35 1.95-4.821 3.286-7.007 1.173-1.918 2.674-3.738 4.37-5.21 3.006-2.61 6.337-2.183 9.098.814 5.13-3.748 8.297-3.339 12.007 1.757 1.39 1.908 2.462 4.049 3.985 6.593V.294c3.317.356 5.543 2.208 6.784 4.669 2.194 4.349 4.53 8.808 5.626 13.498 4.1 17.554 3.803 35.09-2.17 52.243-1.13 3.246-3.282 6.194-5.286 9.053-1.37 1.958-3.42 3.29-6.457 3.229v-7.912c-8.027 9.452-9.396 9.87-15.912 5.056-.725 2.797-3.887 3.843-6.962 2.185-3.348-1.805-5.248-4.86-6.654-8.248-.747-1.796-1.338-3.659-2.37-5.475-.25 4.543-.502 9.088-.772 14.013-3.727-1.991-5.712-5.172-7.17-8.746-5.194-12.729-6.122-26.101-5.333-39.587.481-8.235 2.038-16.404 5.36-24.057 1.094-2.519 2.648-4.897 4.332-7.076.97-1.255 2.622-1.981 4.238-3.139zm49.468 4.542c2.721 3.517 4.255 7.607 5.49 11.837 3.12 10.684 3.62 21.676 2.695 32.608-.597 7.094-2.45 14.14-4.346 21.04-.935 3.402-3.247 6.422-4.936 9.617-.306-.109-.615-.215-.92-.322.113-1.816.218-3.635.345-5.451.04-.562.198-1.12.205-1.683.174-13.582.376-27.165.486-40.75.073-8.904.014-17.81.014-26.716l.967-.18zM18.391 5.68c0 6.746.049 12.972-.009 19.198-.133 14.559-.306 29.116-.495 43.672-.033 2.468-.231 4.935-.377 7.922-9.495-16.013-9.502-54.987.881-70.792zm81.71 12.801c3.888 15.867 3.8 31.66-1.079 47.409l1.079-47.409zM1.782 21.963v37.804c-2.445-7.858-2.306-29.898 0-37.804z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default IconEffect1;
